import { render, staticRenderFns } from "./areaOfStudyImport.vue?vue&type=template&id=8608af2a"
import script from "./areaOfStudyImport.vue?vue&type=script&lang=js"
export * from "./areaOfStudyImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports